import React, {FC} from 'react'
import classnames from 'classnames'
import StylesType from '@/types/StylesType'
import Table from '@/components/Table'
import {Col, Row, Checkbox} from "antd";
import './style/DeviceTable.less'
import {DeviceType} from '@/types/NewMachineTypes'
import {secondToObj} from '@/utils/secondToDay'

interface DeviceTableType {
  deviceList: (DeviceType)[];
  selectedIds: number[];
  toggleDevice: (checkedValue: any) => void;
  deviceCol?: number
}

type DeviceTableProps = StylesType & DeviceTableType
const DeviceTable: FC<DeviceTableProps> = props => {
  const {prefixCls = 'gc_', className, deviceList = [], toggleDevice, selectedIds, deviceCol = 1} = props
  const columns = [
    {
      title: '设备CID',
      dataIndex: 'cid',
      ellipsis: true,
      render: (text: string, recond: DeviceType) => {
        return (
          <>
            <Checkbox value={recond.id}></Checkbox>
            <span>{text}</span>
          </>
        )
      }
    }, {
      title: '设备剩余时间',
      dataIndex: 'endTime',
      ellipsis: true,
      render: (text: number) => {
        let second = text - (new Date().getTime() / 1000) - 1800
        if (second > 0) {
          let data = secondToObj(second)
          return `${data.days}天${data.hours}时${data.minutes}分`
        }
        return '已过期'
      }
    }, {
      title: '服务剩余时间',
      ellipsis: true,
      dataIndex: 'vasNewEndTime',
      render: (text: number) => {
        let second = text - (new Date().getTime() / 1000)
        if (text > 0) {
          let data = secondToObj(second)
          return `${data.days}天${data.hours}时${data.minutes}分`
        }
        return '-'
      }
    },
  ]
  return (
    <>
      <Checkbox.Group style={{width: '100%'}} onChange={toggleDevice} value={selectedIds}>
        <Row type='flex' gutter={[0, 0]} justify='center' className={classnames(prefixCls + 'Device_table', className)}>
          {
            new Array(deviceCol).fill(1).map((items, indexs) => {
              return <Col span={24 / deviceCol} key={indexs}>
                <Table columns={columns}
                       rowKey="cid"
                       dataSource={deviceList.filter((item, index) => index % deviceCol === indexs)}
                       className={classnames('Device_table_item')} pagination={false}>
                </Table>
              </Col>
            })
          }
        </Row>
      </Checkbox.Group>
    </>
  )
}
export default DeviceTable
